var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-icon',_vm._g(_vm._b({attrs:{"small":"","color":_vm.color || 'inherit'}},'v-icon',attrs,false),on),[_vm._v(" info ")])]}}])},[(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }